export enum ClientType {
  ALL_CLIENTS = 'ALL_CLIENTS',
  ANDROID_MOBILE = 'ANDROID_MOBILE',
  ANDROID_TV = 'ANDROID_TV',
  CHROMECAST = 'CHROMECAST',
  COMCAST_FLEX = 'COMCAST_FLEX',
  COMCAST_XUMO = 'COMCAST_XUMO',
  FIRE_TV = 'FIRE_TV',
  INTERNAL = 'INTERNAL',
  IOS = 'IOS',
  LG_WEBOS = 'LG_WEBOS',
  MLB_AVR = 'MLB_AVR',
  MLB_VR = 'MLB_VR',
  PLAYSTATION = 'PLAYSTATION',
  ROKU = 'ROKU',
  SAMSUNG = 'SAMSUNG',
  TIZEN = 'TIZEN',
  TV_OS = 'TV_OS',
  WEB = 'WEB',
  XBOX = 'XBOX',
}
export interface MatchParams {
  clientType?: ClientType;
  userId?: string;
}

export interface Override {
  clientType: ClientType;
  id: string;
  userId: string;
}
